import PhotoSearchCard from './PhotoSearchCard';

export default PhotoSearchCard;



// WEBPACK FOOTER //
// ./src/components/PhotoSearchCard/index.js